"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagedGrid = void 0;
var React = require("react");
var index_1 = require("../Grid/index");
var PagedGrid = function (_a) {
    var Data = _a.Data, Headers = _a.Headers, CellEditingStopped = _a.CellEditingStopped, PaginationPageSize = _a.PaginationPageSize, OnGridReady = _a.OnGridReady, GetRowNodeId = _a.GetRowNodeId, DragLeaveHidesColumns = _a.DragLeaveHidesColumns, SaveLayout = _a.SaveLayout, SaveLayoutID = _a.SaveLayoutID, DeltaRowDataMode = _a.DeltaRowDataMode, ImmutableData = _a.ImmutableData, OnGridLayoutChange = _a.OnGridLayoutChange, AutoHeight = _a.AutoHeight, StickyControls = _a.StickyControls, DisablePaginationBackground = _a.DisablePaginationBackground, ScrollContainer = _a.ScrollContainer, FirstStickyPosition = _a.FirstStickyPosition, SecondStickyPosition = _a.SecondStickyPosition, props = __rest(_a, ["Data", "Headers", "CellEditingStopped", "PaginationPageSize", "OnGridReady", "GetRowNodeId", "DragLeaveHidesColumns", "SaveLayout", "SaveLayoutID", "DeltaRowDataMode", "ImmutableData", "OnGridLayoutChange", "AutoHeight", "StickyControls", "DisablePaginationBackground", "ScrollContainer", "FirstStickyPosition", "SecondStickyPosition"]);
    var gridRef = React.createRef();
    React.useEffect(function () {
        if (ScrollContainer) {
            var onScroll_1 = function () {
                var _a, _b, _c, _d, _e, _f, _g;
                var box = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (box) {
                    if (SecondStickyPosition) {
                        if (box.top < FirstStickyPosition && box.top > SecondStickyPosition) {
                            (_b = gridRef.current) === null || _b === void 0 ? void 0 : _b.classList.add("sr-fixed-grid-header");
                        }
                        else if (box.top <= SecondStickyPosition) {
                            (_c = gridRef.current) === null || _c === void 0 ? void 0 : _c.classList.add("sr-fixed-grid-header-top");
                        }
                        else {
                            (_d = gridRef.current) === null || _d === void 0 ? void 0 : _d.classList.remove("sr-fixed-grid-header");
                            (_e = gridRef.current) === null || _e === void 0 ? void 0 : _e.classList.remove("sr-fixed-grid-header-top");
                        }
                    }
                    else {
                        if (box.top < FirstStickyPosition) {
                            (_f = gridRef.current) === null || _f === void 0 ? void 0 : _f.classList.add("sr-fixed-grid-header");
                        }
                        else {
                            (_g = gridRef.current) === null || _g === void 0 ? void 0 : _g.classList.remove("sr-fixed-grid-header");
                        }
                    }
                }
            };
            document.querySelector(ScrollContainer).addEventListener("scroll", onScroll_1);
            return function () {
                document.querySelector(ScrollContainer).removeEventListener("scroll", onScroll_1);
            };
        }
    }, [gridRef]);
    var GridComponent = function () { return (React.createElement("div", { style: { height: "100%" }, ref: gridRef },
        React.createElement(index_1.Grid, __assign({ domLayout: AutoHeight ? "autoHeight" : "normal", SaveLayout: SaveLayout, SaveLayoutID: SaveLayoutID, OnGridLayoutChange: OnGridLayoutChange, pagination: true, paginationPageSize: PaginationPageSize, defaultColDef: { resizable: true, filter: true, sortable: true }, columnDefs: Headers, rowData: Data, onCellEditingStopped: CellEditingStopped, onGridReady: OnGridReady, getRowNodeId: GetRowNodeId, suppressDragLeaveHidesColumns: !DragLeaveHidesColumns, deltaRowDataMode: DeltaRowDataMode, immutableData: ImmutableData, ScrollContainer: ScrollContainer, FirstStickyPosition: FirstStickyPosition, SecondStickyPosition: SecondStickyPosition }, props)))); };
    if (StickyControls) {
        var classNames = ["sr-sticky-controls-v2"];
        if (!DisablePaginationBackground) {
            classNames.push("sr-pagination-background");
        }
        return (React.createElement("div", { className: classNames.join(" ") },
            React.createElement(GridComponent, null)));
    }
    return React.createElement(GridComponent, null);
};
exports.PagedGrid = PagedGrid;
